import { useQuery } from "@tanstack/react-query";
import { Api } from "../openApi";
import { GetApiCancerInsurancesInsuranceCode200Response } from "../openApi/api";

export const useCancerInsuranceDetail = (
  insuranceCode: string,
  setResponse: (
    response: GetApiCancerInsurancesInsuranceCode200Response
  ) => void
) => {
  return useQuery(
    ["getCancerInsuranceDetail"],
    async () => {
      const { data } = await Api.getApiCancerInsurancesInsuranceCode(
        insuranceCode
      );
      setResponse(data);
      return data;
    },
    {
      enabled: false,
    }
  );
};
